import { n } from './query-assigned-elements-1c8c9e90.js';

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function t(t){return n({...t,state:!0})}

export { t };
